import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog"
import { WorkflowRunningProps } from "@/types/workflow"
import React from "react"
import { LoadingSpinner } from "../LoadingSpinner/LoadingSpinner"

export const WorkflowRunning: React.FC<WorkflowRunningProps> = ({
  actionButtonText,
  dialogTitle,
  dialogSubtitle,
  variant
}) => {

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button className="text-accent font-medium underline mr-3 flex flex-row items-center">
          {actionButtonText}
          <LoadingSpinner className="h-5 w-5 ml-2" />
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader className="flex flex-col items-center">
          <div className="w-full mb-8 flex flex-row justify-center items-center">
            <LoadingSpinner />
          </div>
          <AlertDialogTitle className="mb-6 text-center">
            {dialogTitle}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            {dialogSubtitle}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="flex flex-col items-center">
          <AlertDialogCancel variant={variant}>
            Close
          </AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  )
}
